"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9203],{

/***/ 40654:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



function SvgChatIcon(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    stroke: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M17 8h2a2 2 0 012 2v6a2 2 0 01-2 2h-2v4l-4-4H9a1.994 1.994 0 01-1.414-.586m0 0L11 14h4a2 2 0 002-2V6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2v4l.586-.586z"
  })));
}

/* harmony default export */ __webpack_exports__["Z"] = (SvgChatIcon);

/***/ }),

/***/ 49224:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var _path, _path2, _path3, _path4, _path5;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



function SvgLogoOnBlack(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    width: 402,
    height: 65,
    viewBox: "0 0 402 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M49.26 30.66c8.102 0 14.67-6.568 14.67-14.67S57.362 1.32 49.26 1.32 34.59 7.888 34.59 15.99s6.568 14.67 14.67 14.67z",
    fill: "#FAFAEE"
  })), _path2 || (_path2 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M30.2 1.26H.85v29.35H30.2V1.26z",
    fill: "#EE9AB2"
  })), _path3 || (_path3 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M49.26 36.87l7.66 13.55 7.66 13.56H33.95l7.65-13.56 7.66-13.55z",
    fill: "#FFC550"
  })), _path4 || (_path4 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M15.52 64.19c8.102 0 14.67-6.568 14.67-14.67s-6.568-14.67-14.67-14.67S.85 41.418.85 49.52s6.568 14.67 14.67 14.67z",
    fill: "#5263F3"
  })), _path5 || (_path5 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M108.58 22.51v9.38a9.201 9.201 0 00-3.82-.75c-5.89 0-10.2 4.65-10.2 11.86v21h-10V22.51h10v6.14c2.24-4.15 5.81-6.8 10.37-6.8 1.247-.01 2.485.214 3.65.66zM150.45 45.08h-33c.75 6.63 5.73 11.12 11.95 11.12a12.171 12.171 0 0010.79-6.14l8.46 3.4c-3.32 6.88-10.54 11.36-19 11.36-13.86 0-22.32-9.54-22.32-21.57 0-12.03 9.13-21.57 22.07-21.57 12 0 21.07 8.63 21.24 21.24l-.19 2.16zm-32.1-7.3h21.32a10.478 10.478 0 00-10.46-7.64 11.168 11.168 0 00-10.86 7.64zM151.99 43.25c0-12.36 9.87-21.57 22.4-21.57 9 0 16.76 4.81 20.16 13l-9 3.73a11.795 11.795 0 00-11.2-7.47c-7.22 0-12.36 5.15-12.36 12.28 0 7.13 5.14 12.28 12.36 12.28a11.8 11.8 0 0011.2-7.47l9 3.74c-3.4 8.21-11.12 13-20.16 13-12.58.05-22.4-9.16-22.4-21.52zM197.49 1.77h10v62.22h-10V1.77zM255.991 22.51v41.48h-10v-5c-3.16 3.65-7.8 5.8-13.78 5.8-11.2 0-20.49-9.54-20.49-21.57 0-12.03 9.29-21.57 20.49-21.57 6 0 10.62 2.16 13.78 5.81v-5l10 .05zm-9.71 20.74a12.28 12.28 0 10-12.29 12.28 12.211 12.211 0 0012.26-12.28h.03zM261.841 6.91a5.997 5.997 0 017.102-6.008 5.998 5.998 0 014.451 8.168 6.003 6.003 0 01-9.757 2.012 6.002 6.002 0 01-1.796-4.172zm.91 15.6h10v41.48h-10V22.51zM338.99 37.69v26.3h-10V38.44a7.223 7.223 0 00-2.086-5.327 7.232 7.232 0 00-5.304-2.143c-4.4 0-7.3 3.49-7.3 7.8v25.22h-10V38.44a7.218 7.218 0 00-7.38-7.47c-4.48 0-7.3 3.49-7.3 7.8v25.22h-10V22.51h10v4.07a12.897 12.897 0 019.95-4.9 14.602 14.602 0 0111.78 6.47 14.597 14.597 0 0112.28-6.47c8.75 0 15.36 7.05 15.36 16.01zM385.92 22.51v41.48h-6.8v-6c-3.57 4.23-9 6.8-15.6 6.8-11.12 0-20.74-9.62-20.74-21.57 0-11.95 9.62-21.57 20.74-21.57 6.64 0 12 2.57 15.6 6.8v-6l6.8.06zm-6.8 20.74a14.77 14.77 0 10-14.77 14.77 14.698 14.698 0 0014.77-14.77zM392.681 5.59a4.648 4.648 0 017.904-3.41 4.648 4.648 0 01-3.254 7.97 4.64 4.64 0 01-4.65-4.56zm1.25 16.92h6.8v41.48h-6.8V22.51z",
    fill: "#FAFAEE"
  })));
}

/* harmony default export */ __webpack_exports__["Z"] = (SvgLogoOnBlack);

/***/ }),

/***/ 15165:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



function SvgLogoOnBlurple(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    width: 402,
    height: 65,
    viewBox: "0 0 402 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M49.26 29.86c8.102 0 14.67-6.568 14.67-14.67S57.362.52 49.26.52 34.59 7.088 34.59 15.19s6.568 14.67 14.67 14.67z",
    fill: "#171D26"
  })), _path2 || (_path2 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M30.2.46H.85v29.35H30.2V.46z",
    fill: "#EE9AB2"
  })), _path3 || (_path3 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M49.26 36.07l7.66 13.55 7.66 13.56H33.95l7.65-13.56 7.66-13.55z",
    fill: "#FFC550"
  })), _path4 || (_path4 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M15.52 63.39c8.102 0 14.67-6.568 14.67-14.67s-6.568-14.67-14.67-14.67S.85 40.618.85 48.72s6.568 14.67 14.67 14.67zM108.58 21.71v9.38a9.201 9.201 0 00-3.82-.75c-5.89 0-10.2 4.65-10.2 11.86v21h-10V21.71h10v6.14c2.24-4.15 5.81-6.8 10.37-6.8 1.247-.01 2.485.214 3.65.66zM150.45 44.28h-33c.75 6.63 5.73 11.12 11.95 11.12a12.172 12.172 0 0010.79-6.14l8.46 3.4c-3.32 6.88-10.54 11.36-19 11.36-13.86 0-22.32-9.54-22.32-21.57 0-12.03 9.13-21.57 22.07-21.57 12 0 21.07 8.63 21.24 21.24l-.19 2.16zm-32.1-7.3h21.32a10.478 10.478 0 00-10.46-7.64 11.168 11.168 0 00-10.86 7.64zM151.99 42.45c0-12.36 9.87-21.57 22.4-21.57 9 0 16.76 4.81 20.16 13l-9 3.73a11.795 11.795 0 00-11.2-7.47c-7.22 0-12.36 5.15-12.36 12.28 0 7.13 5.14 12.28 12.36 12.28a11.8 11.8 0 0011.2-7.47l9 3.74c-3.4 8.21-11.12 13-20.16 13-12.58.05-22.4-9.16-22.4-21.52zM197.49.97h10v62.22h-10V.97zM255.99 21.71v41.48h-10v-5c-3.16 3.65-7.8 5.8-13.78 5.8-11.2 0-20.49-9.54-20.49-21.57 0-12.03 9.29-21.57 20.49-21.57 6 0 10.62 2.16 13.78 5.81v-5l10 .05zm-9.71 20.74a12.28 12.28 0 10-12.29 12.28 12.206 12.206 0 0011.346-7.574c.613-1.493.923-3.093.914-4.706h.03zM261.84 6.11a6.006 6.006 0 013.627-5.621 6 6 0 11-3.627 5.621zm.91 15.6h10v41.48h-10V21.71zM338.99 36.89v26.3h-10V37.64a7.223 7.223 0 00-2.086-5.327 7.233 7.233 0 00-5.304-2.143c-4.4 0-7.3 3.49-7.3 7.8v25.22h-10V37.64a7.218 7.218 0 00-7.38-7.47c-4.48 0-7.3 3.49-7.3 7.8v25.22h-10V21.71h10v4.07a12.898 12.898 0 019.95-4.9 14.602 14.602 0 0111.78 6.47 14.597 14.597 0 0112.28-6.47c8.75 0 15.36 7.05 15.36 16.01zM385.92 21.71v41.48h-6.8v-6c-3.57 4.23-9 6.8-15.6 6.8-11.12 0-20.74-9.62-20.74-21.57 0-11.95 9.62-21.57 20.74-21.57 6.64 0 12 2.57 15.6 6.8v-6l6.8.06zm-6.8 20.74a14.77 14.77 0 10-14.77 14.77 14.698 14.698 0 0014.77-14.77zM392.68 4.79a4.65 4.65 0 114.65 4.56 4.638 4.638 0 01-4.65-4.56zm1.25 16.92h6.8v41.48h-6.8V21.71z",
    fill: "#FAFAEE"
  })));
}

/* harmony default export */ __webpack_exports__["Z"] = (SvgLogoOnBlurple);

/***/ }),

/***/ 29203:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ layouts_LandingLayout; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(10253);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/ListItem/ListItem.js
var ListItem = __webpack_require__(50998);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Button/Button.js
var Button = __webpack_require__(282);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Box/Box.js + 14 modules
var Box = __webpack_require__(50253);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Container/Container.js
var Container = __webpack_require__(43832);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Drawer/Drawer.js
var Drawer = __webpack_require__(39636);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Hidden/Hidden.js + 3 modules
var Hidden = __webpack_require__(53450);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/IconButton/IconButton.js
var IconButton = __webpack_require__(17812);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/MenuList/MenuList.js
var MenuList = __webpack_require__(29829);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/makeStyles.js
var makeStyles = __webpack_require__(41120);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/useTheme.js
var useTheme = __webpack_require__(8920);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/AssignmentTurnedInOutlined.js
var AssignmentTurnedInOutlined = __webpack_require__(67179);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/Cached.js
var Cached = __webpack_require__(85685);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/CalendarTodayOutlined.js
var CalendarTodayOutlined = __webpack_require__(98449);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/Close.js
var Close = __webpack_require__(80366);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/KeyboardArrowDown.js
var KeyboardArrowDown = __webpack_require__(51115);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/LinkRounded.js
var LinkRounded = __webpack_require__(97733);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/Menu.js
var Menu = __webpack_require__(48884);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/RepeatRounded.js
var RepeatRounded = __webpack_require__(85032);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/components/Banner.tsx
var Banner = __webpack_require__(3658);
// EXTERNAL MODULE: ./src/components/CurrentUser.tsx
var CurrentUser = __webpack_require__(54216);
// EXTERNAL MODULE: ./src/components/Link.tsx
var Link = __webpack_require__(34557);
// EXTERNAL MODULE: ./src/components/Loading.tsx
var Loading = __webpack_require__(8080);
// EXTERNAL MODULE: ./src/context/AppContext.tsx
var AppContext = __webpack_require__(64574);
// EXTERNAL MODULE: ./src/context/UserContext.tsx
var UserContext = __webpack_require__(59484);
// EXTERNAL MODULE: ./src/hooks/useOurRouter.ts
var useOurRouter = __webpack_require__(52581);
;// CONCATENATED MODULE: ./src/img/buffer-icon2.svg
var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



function SvgBufferIcon2(props) {
  return /*#__PURE__*/react.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/react.createElement("path", {
    d: "M22 18.82A2.18 2.18 0 0119.82 21M4.18 21A2.18 2.18 0 012 18.82M8 21h2m4 0h2M2 15V4.18A2.18 2.18 0 014.18 2h15.64A2.18 2.18 0 0122 4.18V15H2zM2 15h20",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

/* harmony default export */ var buffer_icon2 = (SvgBufferIcon2);
// EXTERNAL MODULE: ./src/img/chat-icon.svg
var chat_icon = __webpack_require__(40654);
// EXTERNAL MODULE: ./src/img/logo-on-black.svg
var logo_on_black = __webpack_require__(49224);
// EXTERNAL MODULE: ./src/img/logo-on-blurple.svg
var logo_on_blurple = __webpack_require__(15165);
;// CONCATENATED MODULE: ./src/img/logo-on-pink.svg
var logo_on_pink_path, _path2, _path3, _path4, _path5;

function logo_on_pink_extends() { logo_on_pink_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return logo_on_pink_extends.apply(this, arguments); }



function SvgLogoOnPink(props) {
  return /*#__PURE__*/react.createElement("svg", logo_on_pink_extends({
    width: 402,
    height: 65,
    viewBox: "0 0 402 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), logo_on_pink_path || (logo_on_pink_path = /*#__PURE__*/react.createElement("path", {
    d: "M48.41 29.86c8.102 0 14.67-6.568 14.67-14.67S56.512.52 48.41.52 33.74 7.088 33.74 15.19s6.568 14.67 14.67 14.67z",
    fill: "#171D26"
  })), _path2 || (_path2 = /*#__PURE__*/react.createElement("path", {
    d: "M29.35.46H0v29.35h29.35V.46z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/react.createElement("path", {
    d: "M48.41 36.07l7.66 13.55 7.66 13.56H33.1l7.65-13.56 7.66-13.55z",
    fill: "#FFC550"
  })), _path4 || (_path4 = /*#__PURE__*/react.createElement("path", {
    d: "M14.67 63.39c8.102 0 14.67-6.568 14.67-14.67s-6.568-14.67-14.67-14.67S0 40.618 0 48.72s6.568 14.67 14.67 14.67z",
    fill: "#5263F3"
  })), _path5 || (_path5 = /*#__PURE__*/react.createElement("path", {
    d: "M107.73 21.71v9.38a9.2 9.2 0 00-3.82-.75c-5.89 0-10.2 4.65-10.2 11.86v21h-10V21.71h10v6.14c2.24-4.15 5.81-6.8 10.37-6.8a10 10 0 013.65.66zM149.6 44.28h-33c.75 6.63 5.73 11.12 11.95 11.12a12.172 12.172 0 0010.79-6.14l8.46 3.4c-3.32 6.88-10.54 11.36-19 11.36-13.86 0-22.32-9.54-22.32-21.57 0-12.03 9.13-21.57 22.07-21.57 12 0 21.07 8.63 21.24 21.24l-.19 2.16zm-32.1-7.3h21.32a10.484 10.484 0 00-10.46-7.64 11.169 11.169 0 00-10.86 7.64zM151.141 42.45c0-12.36 9.87-21.57 22.4-21.57 9 0 16.76 4.81 20.16 13l-9 3.73a11.804 11.804 0 00-11.2-7.47c-7.22 0-12.36 5.15-12.36 12.28 0 7.13 5.14 12.28 12.36 12.28a11.797 11.797 0 0011.2-7.47l9 3.74c-3.4 8.21-11.12 13-20.16 13-12.58.05-22.4-9.16-22.4-21.52zM196.641.97h10v62.22h-10V.97zM255.141 21.71v41.48h-10v-5c-3.16 3.65-7.8 5.8-13.78 5.8-11.2 0-20.49-9.54-20.49-21.57 0-12.03 9.29-21.57 20.49-21.57 6 0 10.62 2.16 13.78 5.81v-5l10 .05zm-9.71 20.74a12.28 12.28 0 10-12.29 12.28 12.208 12.208 0 0012.26-12.28h.03zM260.991 6.11a5.998 5.998 0 013.627-5.621 6 6 0 11-3.627 5.621zm.91 15.6h10v41.48h-10V21.71zM338.14 36.89v26.3h-10V37.64a7.233 7.233 0 00-7.39-7.47c-4.4 0-7.3 3.49-7.3 7.8v25.22h-10V37.64a7.227 7.227 0 00-4.509-6.945 7.22 7.22 0 00-2.871-.525c-4.48 0-7.3 3.49-7.3 7.8v25.22h-10V21.71h10v4.07a12.895 12.895 0 019.95-4.9 14.598 14.598 0 0111.78 6.47 14.603 14.603 0 0112.28-6.47c8.75 0 15.36 7.05 15.36 16.01zM385.07 21.71v41.48h-6.8v-6c-3.57 4.23-9 6.8-15.6 6.8-11.12 0-20.74-9.62-20.74-21.57 0-11.95 9.62-21.57 20.74-21.57 6.64 0 12 2.57 15.6 6.8v-6l6.8.06zm-6.8 20.74a14.77 14.77 0 10-14.77 14.77 14.702 14.702 0 0014.77-14.77zM391.831 4.79a4.65 4.65 0 114.65 4.56 4.638 4.638 0 01-4.65-4.56zm1.25 16.92h6.8v41.48h-6.8V21.71z",
    fill: "#171D26"
  })));
}

/* harmony default export */ var logo_on_pink = (SvgLogoOnPink);
;// CONCATENATED MODULE: ./src/img/Primary_FullColor.svg
var _defs, _circle, Primary_FullColor_path, Primary_FullColor_path2, _circle2, Primary_FullColor_path3;

function Primary_FullColor_extends() { Primary_FullColor_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return Primary_FullColor_extends.apply(this, arguments); }



function SvgPrimaryFullColor(props) {
  return /*#__PURE__*/react.createElement("svg", Primary_FullColor_extends({
    id: "Primary_FullColor_svg__Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 607.6 96.77"
  }, props), _defs || (_defs = /*#__PURE__*/react.createElement("defs", null, /*#__PURE__*/react.createElement("style", null, ".Primary_FullColor_svg__cls-1{fill:#171d26}"))), _circle || (_circle = /*#__PURE__*/react.createElement("circle", {
    className: "Primary_FullColor_svg__cls-1",
    cx: 73.34,
    cy: 22.8,
    r: 22.23
  })), Primary_FullColor_path || (Primary_FullColor_path = /*#__PURE__*/react.createElement("path", {
    fill: "#ee9ab2",
    d: "M0 .48h44.45v44.45H0z"
  })), Primary_FullColor_path2 || (Primary_FullColor_path2 = /*#__PURE__*/react.createElement("path", {
    fill: "#ffc550",
    d: "M73.34 54.42l11.6 20.54 11.6 20.53h-46.4l11.6-20.53 11.6-20.54z"
  })), _circle2 || (_circle2 = /*#__PURE__*/react.createElement("circle", {
    cx: 22.23,
    cy: 73.58,
    r: 22.23,
    fill: "#5263f3"
  })), Primary_FullColor_path3 || (Primary_FullColor_path3 = /*#__PURE__*/react.createElement("path", {
    className: "Primary_FullColor_svg__cls-1",
    d: "M165.89 32.67v14.21a13.9 13.9 0 00-5.78-1.14c-8.93 0-15.46 7-15.46 18v31.8h-15.21V32.67h15.21V42c3.39-6.28 8.8-10.3 15.71-10.3a15.15 15.15 0 015.53.97zM229.31 66.86h-50c1.13 10 8.67 16.84 18.09 16.84a18.43 18.43 0 0016.34-9.3l12.82 5.15c-5 10.43-16 17.22-28.78 17.22-21 0-33.81-14.46-33.81-32.68s13.83-32.67 33.43-32.67c18.23 0 31.92 13.07 32.18 32.17zM180.68 55.8H213c-2.39-7.17-7.92-11.56-15.84-11.56a16.92 16.92 0 00-16.48 11.56zM231.57 64.09c0-18.72 15-32.67 33.93-32.67 13.7 0 25.38 7.29 30.54 19.73l-13.58 5.65a17.89 17.89 0 00-17-11.31c-10.94 0-18.73 7.79-18.73 18.6s7.79 18.6 18.73 18.6a17.87 17.87 0 0017-11.31L296 77c-5.16 12.44-16.84 19.73-30.54 19.73-18.94.04-33.89-13.91-33.89-32.64zM300.56 1.26h15.21v94.25h-15.21zM389.12 32.67v62.84h-15.2V88c-4.78 5.53-11.82 8.8-20.87 8.8-17 0-31-14.46-31-32.68s14.08-32.67 31-32.67c9.05 0 16.09 3.26 20.87 8.79v-7.57zm-14.7 31.42a18.6 18.6 0 10-18.6 18.6 18.48 18.48 0 0018.6-18.6zM398 9.05a9 9 0 1118.09 0 9 9 0 01-18.09 0zm1.38 23.62h15.2v62.84h-15.2zM514.94 55.67v39.84h-15.21V56.8a10.94 10.94 0 00-11.19-11.31c-6.66 0-11.05 5.28-11.05 11.82v38.2h-15.21V56.8a10.94 10.94 0 00-11.19-11.31c-6.78 0-11 5.28-11 11.82v38.2h-15.26V32.67H440v6.16a19.55 19.55 0 0115.08-7.41c7 0 13.57 3.77 17.84 9.8a22.1 22.1 0 0118.6-9.8c13.36 0 23.42 10.68 23.42 24.25zM586 32.67v62.84h-10.3v-9.05c-5.41 6.41-13.58 10.31-23.63 10.31-16.84 0-31.42-14.58-31.42-32.68s14.58-32.67 31.42-32.67c10.05 0 18.22 3.89 23.63 10.3v-9zm-10.3 31.42a22.37 22.37 0 10-22.37 22.37 22.26 22.26 0 0022.35-22.37zM596.23 7a7 7 0 1114.07 0 7 7 0 01-14.07 0zm1.88 25.63h10.31v62.88h-10.31z",
    transform: "translate(-2.7)"
  })));
}

/* harmony default export */ var Primary_FullColor = (SvgPrimaryFullColor);
// EXTERNAL MODULE: ./src/img/puzzle-icon.svg
var puzzle_icon = __webpack_require__(73766);
;// CONCATENATED MODULE: ./src/layouts/LandingLayout.tsx





































var useStyles = (0,makeStyles/* default */.Z)(function(theme) {
    var _obj, _obj1, _obj2;
    return {
        root: {
            display: "grid",
            gridTemplateColumns: "auto",
            gridTemplateRows: "min-content auto",
            gridTemplateAreas: '"header" "main"',
            height: "100%",
            width: "100%"
        },
        header: {
            gridArea: "header",
            position: "relative",
            zIndex: 10,
            "& $headerContainer": (_obj = {
                display: "flex",
                alignItems: "center",
                maxWidth: "1292px",
                padding: theme.spacing(1, 3)
            }, (0,_define_property/* default */.Z)(_obj, theme.breakpoints.up("sm"), {
                padding: theme.spacing(0, 4)
            }), (0,_define_property/* default */.Z)(_obj, theme.breakpoints.up("lg"), {
                padding: theme.spacing(0, 9.5)
            }), _obj)
        },
        main: {
            gridArea: "main",
            display: "flex",
            flexDirection: "column",
            flexGrow: 1
        },
        headerContainer: {},
        title: {
            maxWidth: "50%",
            "& :hover": {
                background: "transparent"
            }
        },
        logoBtn: {
            display: "block",
            maxWidth: 200,
            paddingLeft: theme.spacing(0.5),
            "&&:hover": {
                backgroundColor: "transparent"
            }
        },
        links: {
            alignItems: "center",
            display: "flex",
            flex: 1,
            justifyContent: "flex-end"
        },
        link: (_obj1 = {}, (0,_define_property/* default */.Z)(_obj1, theme.breakpoints.down("md"), (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, theme.typography.h1), {
            color: theme.colors.white,
            display: "block",
            fontFamily: "Poppins"
        })), (0,_define_property/* default */.Z)(_obj1, theme.breakpoints.up("md"), (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, theme.typography.body1), {
            color: theme.colors.logo.darkness,
            display: "flex",
            fontWeight: theme.typography.fontWeightRegular,
            letterSpacing: "normal",
            marginRight: theme.spacing(0.5),
            opacity: 1,
            padding: theme.spacing(1, 1.5),
            transition: "opacity .1s ease-in",
            width: "auto",
            "&$white": {
                color: theme.colors.white
            }
        })), (0,_define_property/* default */.Z)(_obj1, "&:hover", {
            background: "none",
            cursor: "pointer"
        }), _obj1),
        // dropdown menu
        menuList: (0,_define_property/* default */.Z)({
            display: "none",
            margin: 0,
            padding: 0
        }, theme.breakpoints.up("md"), {
            backgroundColor: "#2f2e41",
            borderRadius: 8,
            left: 0,
            padding: theme.spacing(1, 0),
            position: "absolute",
            top: 40
        }),
        dropdownLink: {
            "&:hover ul": {
                display: "block"
            }
        },
        menuLink: (0,_define_property/* default */.Z)({
            color: theme.palette.common.white,
            display: "flex",
            fontSize: ".75em",
            opacity: 1,
            padding: theme.spacing(1, 0),
            transition: "opacity .1s ease-in",
            "&:hover": {
                opacity: 0.8,
                textDecoration: "none"
            }
        }, theme.breakpoints.up("md"), {
            fontSize: "1em",
            padding: theme.spacing(0.75, 2)
        }),
        logoSvg: (0,_define_property/* default */.Z)({
            height: "auto",
            width: "100%"
        }, theme.breakpoints.up("sm"), {
            height: "4em",
            width: "8.4em"
        }),
        loginBtn: (_obj2 = {
            width: "auto"
        }, (0,_define_property/* default */.Z)(_obj2, theme.breakpoints.up("md"), {
            borderColor: theme.palette.common.black,
            marginLeft: theme.spacing(),
            "&$white": {
                borderColor: theme.colors.white,
                color: theme.colors.white
            }
        }), (0,_define_property/* default */.Z)(_obj2, theme.breakpoints.down("sm"), (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, theme.typography.h1), {
            border: 0,
            color: theme.colors.logo.shrimp,
            display: "block",
            fontFamily: "Poppins",
            justifyContent: "flex-start",
            padding: theme.spacing(1, 2),
            textAlign: "left"
        })), _obj2),
        hamburger: {
            marginLeft: theme.spacing(1),
            marginRight: theme.spacing(-1),
            "&$white": {
                color: theme.colors.white
            }
        },
        closeIcon: {
            color: theme.colors.white,
            position: "absolute",
            right: theme.spacing(2),
            top: theme.spacing(2),
            zIndex: 10
        },
        carat: (0,_define_property/* default */.Z)({
            height: 24,
            marginLeft: theme.spacing(0.5),
            transform: "translateY(3px)",
            width: 24
        }, theme.breakpoints.up("md"), {
            height: 16,
            transform: "none",
            width: 16
        }),
        featureIcon: (0,_define_property/* default */.Z)({
            height: 20,
            marginRight: theme.spacing(1.5),
            opacity: 0.8,
            width: 20
        }, theme.breakpoints.up("md"), {
            height: 16,
            width: 16
        }),
        white: {},
        navmenu: (0,_define_property/* default */.Z)({
            display: "flex",
            whiteSpace: "nowrap"
        }, theme.breakpoints.down("sm"), {
            alignItems: "flexStart",
            backgroundColor: theme.colors.logo.blurple,
            flexDirection: "column",
            height: "100vh",
            padding: theme.spacing(11, 2, 4)
        }),
        loadingContainer: {
            width: "100vw",
            height: "100vh",
            display: "flex",
            justifyContent: "center",
            alignItems: "center"
        }
    };
}, {
    index: 1,
    name: "LandingLayout"
});
var LandingLayout = function(param) {
    var _loading = param.loading, loading = _loading === void 0 ? false : _loading, _hideNav = param.hideNav, hideNav = _hideNav === void 0 ? false : _hideNav, title = param.title, links = param.links, children = param.children, className = param.className, logoColor = param.logoColor;
    var theme = (0,useTheme/* default */.Z)();
    var classes = useStyles(theme);
    var router = (0,useOurRouter/* useOurRouter */.ED)();
    var ref = (0,_sliced_to_array/* default */.Z)((0,UserContext/* useUserContext */.SE)(), 1), ref1 = ref[0], user = ref1.user, isAuthenticated = ref1.isAuthenticated;
    var ref2 = (0,AppContext/* useAppContext */.bp)(), _state = ref2.state, docTitle = _state.title, dispatch = ref2.dispatch;
    var ref3 = (0,_sliced_to_array/* default */.Z)(react.useState(false), 2), menuOpen = ref3[0], setMenuOpen = ref3[1];
    var menuRef = react.useRef(null);
    var handleSignupClick = (0,react.useCallback)(function() {
        var path = router.route;
        void router.push(path.startsWith("/login") ? "/signup" : "/login");
    }, [
        router
    ]);
    var handleMenuToggle = function() {
        setMenuOpen(function(prevOpen) {
            return !prevOpen;
        });
    };
    var menuLinks = (0,react.useMemo)(function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(MenuList/* default */.Z, {
            className: classes.navmenu,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(ListItem/* default */.Z, {
                    className: (0,clsx_m/* default */.Z)(classes.link, classes.dropdownLink, (logoColor === "blurple" || logoColor === "darkness") && classes.white),
                    children: [
                        "Features",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(KeyboardArrowDown/* default */.Z, {
                            className: classes.carat
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(MenuList/* default */.Z, {
                            className: classes.menuList,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(ListItem/* default */.Z, {
                                    button: true,
                                    component: Link/* Link */.r,
                                    className: classes.menuLink,
                                    href: "//reclaim.ai/features/planner/",
                                    target: "reclaim",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CalendarTodayOutlined/* default */.Z, {
                                            className: classes.featureIcon,
                                            fontSize: "small"
                                        }),
                                        "Planner"
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(ListItem/* default */.Z, {
                                    button: true,
                                    component: Link/* Link */.r,
                                    className: classes.menuLink,
                                    href: "//reclaim.ai/features/habits/",
                                    target: "reclaim",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(RepeatRounded/* default */.Z, {
                                            className: classes.featureIcon,
                                            fontSize: "small"
                                        }),
                                        "Habits"
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(ListItem/* default */.Z, {
                                    button: true,
                                    component: Link/* Link */.r,
                                    className: classes.menuLink,
                                    href: "//reclaim.ai/features/tasks/",
                                    target: "reclaim",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(AssignmentTurnedInOutlined/* default */.Z, {
                                            className: classes.featureIcon
                                        }),
                                        "Tasks"
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(ListItem/* default */.Z, {
                                    button: true,
                                    component: Link/* Link */.r,
                                    className: classes.menuLink,
                                    href: "//reclaim.ai/features/smart-one-on-ones",
                                    target: "reclaim",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(chat_icon/* default */.Z, {
                                            className: classes.featureIcon
                                        }),
                                        "Smart 1:1s"
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(ListItem/* default */.Z, {
                                    button: true,
                                    component: Link/* Link */.r,
                                    className: classes.menuLink,
                                    href: "//reclaim.ai/features/calendar-sync/",
                                    target: "reclaim",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Cached/* default */.Z, {
                                            className: classes.featureIcon
                                        }),
                                        "Calendar Sync"
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(ListItem/* default */.Z, {
                                    button: true,
                                    component: Link/* Link */.r,
                                    className: classes.menuLink,
                                    href: "//reclaim.ai/features/buffer-time",
                                    target: "reclaim",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(buffer_icon2, {
                                            className: classes.featureIcon
                                        }),
                                        "Buffer Time"
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(ListItem/* default */.Z, {
                                    button: true,
                                    component: Link/* Link */.r,
                                    className: classes.menuLink,
                                    href: "//reclaim.ai/features/scheduling-links",
                                    target: "reclaim",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkRounded/* default */.Z, {
                                            className: (0,clsx_m/* default */.Z)(classes.featureIcon)
                                        }),
                                        "Scheduling Links"
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(ListItem/* default */.Z, {
                                    button: true,
                                    component: Link/* Link */.r,
                                    className: classes.menuLink,
                                    href: "//reclaim.ai/integrations/",
                                    target: "reclaim",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(puzzle_icon/* default */.Z, {
                                            className: classes.featureIcon
                                        }),
                                        "Integrations"
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItem/* default */.Z, {
                    disableRipple: true,
                    className: (0,clsx_m/* default */.Z)(classes.link, (logoColor === "blurple" || logoColor === "darkness") && classes.white),
                    button: true,
                    component: Link/* Link */.r,
                    href: "//reclaim.ai/use-cases/",
                    title: "Use Cases",
                    target: "reclaim",
                    children: "Use Cases"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItem/* default */.Z, {
                    disableRipple: true,
                    className: (0,clsx_m/* default */.Z)(classes.link, (logoColor === "blurple" || logoColor === "darkness") && classes.white),
                    button: true,
                    component: Link/* Link */.r,
                    href: "//reclaim.ai/pricing/",
                    title: "Pricing",
                    target: "reclaim-help",
                    children: "Pricing"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItem/* default */.Z, {
                    disableRipple: true,
                    className: (0,clsx_m/* default */.Z)(classes.link, (logoColor === "blurple" || logoColor === "darkness") && classes.white),
                    button: true,
                    component: Link/* Link */.r,
                    href: "//blog.reclaim.ai",
                    title: "Reclaim Blog",
                    target: "reclaim-blog",
                    children: "Blog"
                }),
                !isAuthenticated && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItem/* default */.Z, {
                            disableRipple: true,
                            className: (0,clsx_m/* default */.Z)(classes.link, (logoColor === "blurple" || logoColor === "darkness") && classes.white),
                            button: true,
                            component: Link/* Link */.r,
                            onClick: handleSignupClick,
                            title: "Log in",
                            target: "reclaim-login",
                            children: "Log in"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                            className: (0,clsx_m/* default */.Z)(classes.loginBtn, (logoColor === "blurple" || logoColor === "darkness") && classes.white),
                            onClick: handleSignupClick,
                            title: "Get Started Free",
                            variant: "outlined",
                            children: "Get Started Free"
                        })
                    ]
                })
            ]
        });
    }, [
        classes.carat,
        classes.loginBtn,
        isAuthenticated,
        handleSignupClick,
        classes.dropdownLink,
        classes.featureIcon,
        classes.link,
        classes.menuLink,
        classes.menuList,
        classes.navmenu,
        classes.white,
        logoColor, 
    ]);
    var defaultLinks = (0,react.useMemo)(function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Hidden/* default */.Z, {
                    smDown: true,
                    children: menuLinks
                }),
                !!isAuthenticated && /*#__PURE__*/ (0,jsx_runtime.jsx)(CurrentUser/* CurrentUser */.I, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Hidden/* default */.Z, {
                    mdUp: true,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                            ref: menuRef,
                            className: (0,clsx_m/* default */.Z)(classes.hamburger, (logoColor === "blurple" || logoColor === "darkness") && classes.white),
                            "aria-controls": menuOpen ? "menu-list-grow" : undefined,
                            "aria-haspopup": "true",
                            onClick: handleMenuToggle,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Menu/* default */.Z, {})
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Drawer/* default */.ZP, {
                            open: menuOpen,
                            anchor: "top",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                                    ref: menuRef,
                                    className: classes.closeIcon,
                                    "aria-controls": menuOpen ? "menu-list-grow" : undefined,
                                    "aria-haspopup": "true",
                                    onClick: handleMenuToggle,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Close/* default */.Z, {})
                                }),
                                menuLinks
                            ]
                        })
                    ]
                })
            ]
        });
    }, [
        classes.closeIcon,
        classes.hamburger,
        classes.white,
        isAuthenticated,
        menuLinks,
        menuOpen,
        logoColor
    ]);
    (0,react.useEffect)(function() {
        dispatch({
            type: AppContext/* AppContextActionType.Theme */.cX.Theme,
            payload: "light"
        });
    }, [
        dispatch
    ]);
    (0,react.useEffect)(function() {
        dispatch({
            type: AppContext/* AppContextActionType.Title */.cX.Title,
            payload: title
        });
    }, [
        dispatch,
        title
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
        className: (0,clsx_m/* default */.Z)(classes.root, className),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        children: /^Reclaim/.test(docTitle) ? docTitle : "".concat(docTitle, " | Reclaim")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "robots",
                        content: "all"
                    }, "robots"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "title",
                        content: docTitle
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "og:title",
                        content: docTitle
                    }, "ogTitle"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:title",
                        content: docTitle
                    }, "twitterTitle")
                ]
            }),
            !!loading && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                className: classes.loadingContainer,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Loading/* Loading */.g, {})
            }),
            !loading && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                        component: "header",
                        className: classes.header,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Banner/* Banner */.j, {
                                in: true,
                                size: "big",
                                variant: "dark",
                                children: [
                                    "\uD83C\uDF89 Create your free account \xa0",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* Link */.r, {
                                        href: "/signup",
                                        children: "Get started - it's free!"
                                    })
                                ]
                            }),
                            !hideNav && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
                                className: classes.headerContainer,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                        className: classes.title,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                                            className: classes.logoBtn,
                                            component: Link/* Link */.r,
                                            href: !!user ? "/" : "//reclaim.ai",
                                            size: "medium",
                                            "aria-label": "reclaim.ai",
                                            disableRipple: true,
                                            disableFocusRipple: true,
                                            children: function() {
                                                switch(logoColor){
                                                    case "shrimp":
                                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(logo_on_pink, {
                                                            className: classes.logoSvg
                                                        });
                                                    case "blurple":
                                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(logo_on_blurple/* default */.Z, {
                                                            className: classes.logoSvg
                                                        });
                                                    case "darkness":
                                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(logo_on_black/* default */.Z, {
                                                            className: classes.logoSvg
                                                        });
                                                    default:
                                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Primary_FullColor, {
                                                            className: classes.logoSvg
                                                        });
                                                }
                                            }()
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                        className: classes.links,
                                        children: links || defaultLinks
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("main", {
                        className: classes.main,
                        children: children
                    })
                ]
            })
        ]
    }, "LandingLayout");
};
/* harmony default export */ var layouts_LandingLayout = (LandingLayout);


/***/ })

}]);